import FulfillmentSettings from "./FulfillmentSettings";

const StoreSettings = (props) => <FulfillmentSettings kind="store" {...props} />;

export default StoreSettings;
